import { HttpStatusCode } from '@angular/common/http';

export const VALIDATION_ERROR_CODES = [
  HttpStatusCode.UnprocessableEntity,
  HttpStatusCode.BadRequest,
];
